import React, { useContext } from 'react';
import './sliderHome.css';
import { LanguageContext } from '../../context/LanguageContext/LanguageContext';
import { sliderData, sliderDataEn } from '../../json/sliderData';

const SliderHome = () => {
    const { language } = useContext(LanguageContext);
    const data = language === 'ES' ? sliderData : sliderDataEn;

    // Asumimos que la primera entrada del slider contiene la información del GIF
    const slide = data[0];

    return (
        <section className="slider-home">
            <div className="media-container">
                <div
                    className="gif-container"
                    style={{
                        backgroundImage: `url(/assets/imgs/sliderHome/HomeBackground/custom_sky_effect.gif)`
                    }}
                ></div>

            </div>
            <div className="overlay">
                <h3>
                    {slide.titleLine1} <br />
                    {slide.titleLine2} <br />
                    <span>{slide.highlight}</span>
                </h3>
            </div>
            <div
                className="red-label"
                style={{ backgroundColor: slide.labelColor }}
            >
                <p>{slide.labelText}</p>
            </div>
        </section>
    );
};

export default SliderHome;
